import { resolveEventDisplayName } from '../../utils/eventDisplayName';

/**
 * The map's title card, one rule for every map (Sam, 2026-10-06):
 *   a festival (or any event's own map):  title = the event's display name,  subtext = venue · city
 *   a venue map (a published venue edition, migration 143):  title = the venue,  subtext = the city
 * The title used to be whatever the grounds were called when the map was built ("HEAD TRIP 2026").
 */

/** A venue's name as people say it. Ticketmaster lists one venue under two ids with two spellings - "Greek Theatre"
 *  and "Greek Theatre-Los Angeles" - so a trailing city (after a dash or a comma) is dropped when it is the venue's city. */
export function venueDisplayName(venue) {
  const name = String(venue?.name ?? '').trim();
  const city = String(venue?.city ?? '').trim();
  if (!name || !city) return name;
  const esc = city.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const stripped = name.replace(new RegExp(`\\s*(?:[-–—,]\\s*)${esc}$`, 'i'), '').trim();
  return stripped || name;
}

/** { title, subtitle } for the map of `event` at `venue`; `venueMap` when the map is the venue's own edition. */
export function mapTitle({ event, venue, venueMap = false }) {
  const place = venueDisplayName(venue);
  const city = String(venue?.city ?? '').trim();
  if (venueMap) return { title: place || null, subtitle: city || null };
  return {
    title: event ? resolveEventDisplayName(event) : null,
    subtitle: [place, city].filter(Boolean).join(' · ') || null,
  };
}
